import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ConfigurationService, UserService } from '@box-core/services';
import { LanguageService } from '@box-core/services/language.service';
import { BOXDynamicTextElement } from '@box-types';
import { boxDynamicTextToTextElement, generateImageSrc } from '@box/utils';
import { GlobalStateService } from '@box-core/services/global-state.service';

@Injectable()
export class AccountReferralPageService {
  private readonly DEFAULT_IMAGE_URL = '/assets/images/general/talking-people.svg';

  constructor(
    private snackBar: MatSnackBar,
    private configService: ConfigurationService,
    private languageService: LanguageService,
    private globalStateService: GlobalStateService
  ) {}

  public getReferralTextElements(): BOXDynamicTextElement[] {
    const config = this.configService.getConfiguration();
    if (!config) return [];
    const texts = config.referral?.bafV2?.texts ?? [];
    return texts.map((text) => {
      const dynamicTextElement = boxDynamicTextToTextElement(text);
      if (dynamicTextElement.style) dynamicTextElement.style.color = null;
      return dynamicTextElement;
    });
  }

  public getReferralCode(): string {
    const user = this.globalStateService.getUser();
    return user.bringAFriend?.couponCode;
  }

  public getReferralLimit(): number {
    return this.globalStateService.getUser()?.bringAFriend?.referralsLimit;
  }

  public getReferralImageUrl(): string {
    const config = this.configService.getConfiguration();
    const bafImage = config?.referral?.bafV2?.image;
    return generateImageSrc(bafImage) ?? this.DEFAULT_IMAGE_URL;
  }

  public onCopyCodeSuccess(): void {
    const snackConfig: MatSnackBarConfig = { duration: 3000 };
    const snackText = this.languageService.getTextByKey('your_password_was_copied_to_the_clipboard');
    const actionText = this.languageService.getTextByKey('ok_');
    this.snackBar.open(snackText, actionText, snackConfig);
  }
}
